import Popover from "../popover/Popover";
import { Show, type VoidComponent } from "solid-js";
import type { ClassList } from "../../types";
import { Icon } from "../icon/Icon";
import { useTranslation } from "../../state/i18n";
import TextLink from "../link/TextLink";
import Text from "../text/Text";

type InfoButtonProps = {
  title: string;
  description: string;
  href?: string;
  ariaLabel: string;
  classList?: ClassList;
};

const InfoButton: VoidComponent<InfoButtonProps> = (props) => {
  const { t } = useTranslation();

  return (
    <Popover
      variant="md"
      positioning={{ placement: "right" }}
      aria-label={props.title}
      Title={() => <Text as="h3" truncate text={props.title} class="text-header-md text-primary" />}
      Trigger={(triggerProps) => (
        <button
          {...triggerProps}
          class="flex size-4 items-center justify-center rounded-sm focus-visible:outline-default"
          classList={props.classList}
          aria-label={props.ariaLabel}
          title={props.ariaLabel}
        >
          <Icon name="outlineInformationCircle" size="md" type="solid" class="icon-button-icon-tertiary-default" />
        </button>
      )}
    >
      <div class="flex flex-col items-start gap-y-2 text-base-regular">
        <div class="mr-4 wrap-break-word text-secondary">{props.description}</div>
        <Show when={props.href}>
          {(href) => <TextLink href={href()} label={t(($) => $.HELP_CENTER_LINK_OPEN)} isExternal />}
        </Show>
      </div>
    </Popover>
  );
};

export default InfoButton;
